export default api => ({
    me: params => api.get('/admin/users/me'),
})
